'use client';

import Breadcrumbs from '@/components/breadcrumbs/Breadcrumbs';
import type { Breadcrumbs as TBreadcrumbs } from '@fagmobler/types';
import { ZipCode } from '@/components/zip/zipCode';
import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';
import { usePathname } from 'next/navigation';

type PageHeaderProps = {
  breadcrumbs?: TBreadcrumbs;
};

export const PageHeader = ({ breadcrumbs }: PageHeaderProps) => {
  const pathname = usePathname();

  return (
    <div className="print:hidden flex justify-between flex-col md:flex-row">
      {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}
      <ZipCode
        className={twMerge(
          clsx('-order-1 -mt-6 mb-2 md:order-1 md:mt-0 md:mb-2', {
            'order-1': pathname?.includes('/kunde'),
          })
        )}
      />
    </div>
  );
};
